import { initialState } from './initial';
import { actionTypes } from './actions';

export function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.ACTION_PROCESSING:
      return {
        ...state,
        actionProcessing: action.payload,
      };

    case actionTypes.GET_RANKINGS: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case actionTypes.GET_RUBYPLAY_RANKINGS: {
      return {
        ...state,
        rubyPlayRanking: action.payload,
      };
    }

    case actionTypes.SET_WITH_RANKING: {
      return {
        ...state,
        withRanking: action.payload,
      };
    }

    case actionTypes.GET_PRAGMATIC_SLOTS_RANKINGS: {
      return {
        ...state,
        pragmaticSlotsRanking: action.payload,
      };
    }

    case actionTypes.GET_PRAGMATIC_LIVE_RANKINGS: {
      return {
        ...state,
        pragmaticLiveRanking: action.payload,
      };
    }

    default:
      return {
        ...state,
      };
  }
}

export default reducer;
